const getDealerSelectedAccountId = () =>
  window.sessionStorage.getItem("dealerSelectedAccountId") ??
  window.localStorage.getItem("dealerSelectedAccountId");

const setDealerSelectedAccountId = (accountId: string | string[]) => {
  const value = JSON.stringify(accountId);
  window.sessionStorage.setItem("dealerSelectedAccountId", value);
  window.localStorage.setItem("dealerSelectedAccountId", value);
};

const getDefaultAccountId = () =>
  window.sessionStorage.getItem("defaultAccountId");

const setDefaultAccountId = (accountId: string) =>
  window.sessionStorage.setItem("defaultAccountId", accountId);

const getBlockedAccounts = (): string[] => {
  const blocked = window.sessionStorage.getItem("blockedAccounts");
  return blocked ? JSON.parse(blocked) : [];
};

const setBlockedAccounts = (accountIds: string[]) =>
  window.sessionStorage.setItem("blockedAccounts", JSON.stringify(accountIds));

const addBlockedAccount = (accountId: string) => {
  const blocked = getBlockedAccounts();
  if (!blocked.includes(accountId)) {
    blocked.push(accountId);
    setBlockedAccounts(blocked);
  }
};

const getDelegatedUserId = () =>
  window.sessionStorage.getItem("delegateUserId");

const setDelegatedUserId = (userId: string) =>
  window.sessionStorage.setItem("delegateUserId", userId);

const removeDelegatedUserId = () =>
  window.sessionStorage.removeItem("delegateUserId");

const SessionStorage = {
  getDealerSelectedAccountId,
  setDealerSelectedAccountId,
  getDefaultAccountId,
  setDefaultAccountId,
  getBlockedAccounts,
  setBlockedAccounts,
  addBlockedAccount,
  getDelegatedUserId,
  setDelegatedUserId,
  removeDelegatedUserId,
};

export default SessionStorage;
